import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { IAnalyticsContext, IAnalyticsEvent, IAnalyticsProps } from "./analytics.interface";
import ReactGA from "react-ga4";
import { APP_CONFIGS } from "../../constants";
import { AuthenticationContext } from "../authentication/authentication.provider";

const analyticsInitValues = {
    event: undefined,
    setEvent: Function.prototype()
};

export const AnalyticsContext = createContext<IAnalyticsContext>(analyticsInitValues);

const AnalyticsProvider = ({ children }: IAnalyticsProps) => {
    const [event, setEventState] = useState<IAnalyticsEvent>();
    const [fixedParams, setFixedParams] = useState<{ userId?: string; companyId?: string }>({});
    const { user } = useContext(AuthenticationContext);

    useEffect(() => {
        if (ReactGA.isInitialized) return;

        ReactGA.initialize(APP_CONFIGS.analyticsId);
    }, []);

    useEffect(() => {
        if (!user) return;

        setFixedParams({
            userId: user?.id,
            companyId: user?.company.id
        });
    }, [user]);

    const setEvent = useCallback(
        (next: IAnalyticsEvent) => {
            setEventState(next);
            if (!ReactGA.isInitialized) return;

            const timestamp = new Date().toISOString();
            const gEvent = { ...fixedParams, ...next, timestamp };
            console.log("sent event", gEvent);
            ReactGA.event(gEvent.event_name, gEvent);
        },
        [fixedParams]
    );

    return (
        <AnalyticsContext.Provider
            value={{
                event,
                setEvent
            }}>
            {children}
        </AnalyticsContext.Provider>
    );
};

export default AnalyticsProvider;
